module.exports = __webpack_public_path__ + "img/CATEGORY ICON-26.eccbb84f.png";